
export const addListenersToRefLinks = (ref, handler ) => {
  if (!handler) { console.error('no tracking handler passed to addListenersToRefLinks function'); return []; }
  const anchorEls = ref.querySelectorAll('a');
  // map anchor elements and apply attributes and event listener
  const linkData = [ ...anchorEls ].map( (el, i) => {
    el.setAttribute('target', '_blank');
    const isRelExist = el.hasAttribute('rel');
    //const atMatch = el.getAttribute("rel");
    // console.log("codition check",el,!isRelExist,!Boolean(atMatch.match(/nofollow/g)) )
    if (!isRelExist) {
      el.setAttribute('rel', 'noopener noreferrer');
    }
    // pass the iterator to the handler to use in tracking value.
    const listener = (e) => handler(e, i);
    el.addEventListener('click', listener);
    // return element and it's listener so we can remove it later.
    return {
      el,
      listener
    };
  });

  return linkData;
};

// remove listeners from matching element generated by above addListenersToRefLinks function
// this should be call on componentWillUnmount / hooks cleanup functions in the component that uses addListenersToRefLinks
export const removeListenersFromRefLinks = (linkData, debug = false) => {
  linkData.forEach( ({ el, listener }) => {
    el.removeEventListener('click', listener);
    if (debug) console.log('remove event listener from: ', el, listener);
  });
};

// export default { addListenersToRefLinks, removeListenersFromRefLinks };
